import {
  CheckCircleIcon,
  LockClosedIcon,
  XMarkIcon,
  AdjustmentsVerticalIcon,
  DocumentDuplicateIcon,
} from "@heroicons/react/24/outline";
import moment from "moment";
import { formatDate } from "../../../utilities/utils";
import GreenChartSvg from "./svgIcons/GreenChartSvg";
import RedChartSvg from "./svgIcons/RedChartSvg";
import TableExportSvg from "./svgIcons/TableExportSvg";

const currentDate = moment();
const monthStartDate = moment(currentDate).startOf("month");
const quarterStartDate = moment(currentDate).startOf("quarter");
const yearStartDate = moment(currentDate).startOf("year");

export const chartCard = [
  {
    img: CheckCircleIcon,
    imgBgColor: "#16CA7C",
    bgColor: "#ffffff",
    subTitle: "Current",
    title: "Successful Matches",
    price: "1,400",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
  {
    img: LockClosedIcon,
    imgBgColor: "#EE6D24",
    bgColor: "#ffffff",
    subTitle: "Current",
    title: "Pending Matches",
    price: "300",
    chartImg: RedChartSvg,
    percentage: "-0.5%",
    perColor: "#EF2121",
  },
  {
    img: XMarkIcon,
    imgBgColor: "#EF2121",
    bgColor: "#ffffff",
    subTitle: "Current",
    title: "Failed Matches",
    price: "100",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
];

export const teamMetricsCard = [
  {
    number: "37",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "New Enrollments",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
  {
    number: "37",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "Credit Requests",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
  {
    number: "37",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "Support Tickets",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
  {
    number: "37",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "Past Due Accounts",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
];

export const retentionRate = [
  {
    number: "37",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "Beginning Active Accounts",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
  {
    number: "78",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "Ending Active Accounts",
    chartImg: RedChartSvg,
    percentage: "+15%",
    perColor: "#EF2121",
  },
  {
    number: "10",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "New Active Accounts Added:",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
  {
    number: "2",
    numBgColor: "#F1F4F6",
    bgColor: "#1C1C1C",
    title: "Total Accounts Canceled",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
  },
];

export const professionalTable = [
  {
    id: 237645,
    name: "Lindsay Walton",
    email: "lindsay.walton@example.com",
    address: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237646,
    name: "Joe Walton",
    email: "joe.walton@example.com",
    address: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237647,
    name: "Joseph Walton",
    email: "joseph.walton@example.com",
    address: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
];

export const userLeadTable = [
  {
    id: 237645,
    name: "Lindsay Walton",
    email: "lindsay.walton@example.com",
    address: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237646,
    name: "Joe Walton",
    email: "joe.walton@example.com",
    address: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237647,
    name: "Joseph Walton",
    email: "joseph.walton@example.com",
    address: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
];

export const leadsMatchTable = [
  {
    id: 247645,
    name: "Lindsay Walton",
    profession: "Dentist",
    division: "Oral and Maxillofacial",
    service: "Cleaning/Hygienist Services",
    owner: "Lydia Schleifer",
    phone_number: "(555) 555-5555",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 247646,
    name: "Joe Walton",
    profession: "Dentist",
    division: "Oral and Maxillofacial",
    service: "Cleaning/Hygienist Services",
    owner: "Lydia Schleifer",
    phone_number: "(555) 555-5555",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 247647,
    name: "Joseph Walton",
    profession: "Dentist",
    division: "Oral and Maxillofacial",
    service: "Cleaning/Hygienist Services",
    owner: "Lydia Schleifer",
    phone_number: "(555) 555-5555",
    created_at: moment().format("MMMM Do, YYYY"),
  },
];

export const userProfessionalTable = [
  {
    id: 237645,
    name: "Lindsay Walton",
    status: "Active",
    email: "lindsay.walton@example.com",
    address: "Fifth Avenuew,MI",
  },
  {
    id: 237646,
    name: "Joe Walton",
    status: "Past Due",
    email: "joe.walton@example.com",
    address: "Fifth Avenuew,MI",
  },
  {
    id: 237647,
    name: "Joseph Walton",
    status: "Pending",
    email: "joseph.walton@example.com",
    address: "Fifth Avenuew,MI",
  },
  {
    id: 237648,
    name: "Joe Walton",
    status: "Delinquent",
    email: "joe.walton@example.com",
    address: "Fifth Avenuew,MI",
  },
  {
    id: 237649,
    name: "Joseph Walton",
    status: "Canceled",
    email: "joseph.walton@example.com",
    address: "Fifth Avenuew,MI",
  },
];

export const professionalDataCard = [
  {
    imgBgColor: "#16CA7C",
    bgColor: "#ffffff",
    subTitle: "Total Current",
    title: "Active Professionals",
    price: "174",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
    period: "from previous period",
  },
  {
    imgBgColor: "#EE6D24",
    bgColor: "#ffffff",
    subTitle: "Total Current",
    title: "Past Due Accounts",
    price: "16",
    chartImg: RedChartSvg,
    percentage: "-0.5%",
    perColor: "#EF2121",
    period: "from previous period",
  },
  {
    imgBgColor: "#EF2121",
    bgColor: "#ffffff",
    subTitle: "Total Current",
    title: "Cancelled Accounts",
    price: "44",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
    period: "from previous period",
  },
  {
    imgBgColor: "#EF2121",
    bgColor: "#ffffff",
    subTitle: "Total Current",
    title: "Delinquent Accounts",
    price: "36",
    chartImg: RedChartSvg,
    percentage: "-0.5%",
    perColor: "#EF2121",
    period: "from previous period",
  },
];

export const leadsDataCard = [
  {
    title: "Successful Matches",
    price: "7878",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
    period: "from previous period",
  },
  {
    title: "Pending Matches",
    price: "100",
    chartImg: RedChartSvg,
    percentage: "-0.5%",
    perColor: "#EF2121",
    period: "from previous period",
  },
  {
    title: "Failed Matches",
    price: "219",
    chartImg: GreenChartSvg,
    percentage: "+12%",
    perColor: "#16CA7C",
    period: "from previous period",
  },
];

export const allMatchesTable = [
  {
    id: 1,
    name: "Lindsay Walton",
    profession: "Dentist",
    division: "Oral and Maxillofacial",
    service: "Cleaning/Hygienist Services",
    owner: "Lydia Schleifer",
    phone_number: "(555) 555-5555",
    email: "lindsay.walton@example.com",
    location: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 2,
    name: "Joe Walton",
    profession: "Dentist",
    division: "Oral and Maxillofacial",
    service: "Cleaning/Hygienist Services",
    owner: "Lydia Schleifer",
    phone_number: "(555) 555-5555",
    email: "joe.walton@example.com",
    location: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 3,
    name: "Joseph Walton",
    profession: "Dentist",
    division: "Oral and Maxillofacial",
    service: "Cleaning/Hygienist Services",
    owner: "Lydia Schleifer",
    phone_number: "(555) 555-5555",
    email: "joesph.walton@example.com",
    location: "Fifth Avenuew,MI",
    created_at: moment().format("MMMM Do, YYYY"),
  },
];

export const invoiceTable = [
  {
    id: 1,
    tenant: "Lindsay Walton",
    amount: 330,
    profession: "Dentist",
    number_of_leads: 6,
    status: "paid",
    created_at: moment().format("MMMM Do, YYYY"),
    view: "Link to stripe",
  },
  {
    id: 2,
    tenant: "Joe Walton",
    amount: 330,
    profession: "Dentist",
    number_of_leads: 6,
    status: "past due",
    created_at: moment().format("MMMM Do, YYYY"),
    view: "Link to stripe",
  },
  {
    id: 3,
    tenant: "Joseph Walton",
    amount: 330,
    profession: "Dentist",
    number_of_leads: 6,
    status: "credited",
    created_at: moment().format("MMMM Do, YYYY"),
    view: "Link to stripe",
  },
  {
    id: 4,
    tenant: "Joe Walton",
    amount: 330,
    profession: "Dentist",
    number_of_leads: 6,
    status: "past due",
    created_at: moment().format("MMMM Do, YYYY"),
    view: "Link to stripe",
  },
  {
    id: 5,
    tenant: "Joseph Walton",
    amount: 330,
    profession: "Dentist",
    number_of_leads: 6,
    status: "credited",
    created_at: moment().format("MMMM Do, YYYY"),
    view: "Link to stripe",
  },
];

export const creditRequestDataCard = [
  {
    status: "Pending",
    name: "DanielleDiaz",
    email: "xxdaniellad@yahoo.com",
    requested_by: "Didi Kidder",
    lead_id: 237465,
    comment: "Bad contact info bad conatct info",
    credits: 10,
    respond_date: moment().format("MMMM Do, YYYY"),
  },
  {
    status: "Pending",
    name: "DanielleDiaz",
    email: "xxdaniellad@yahoo.com",
    requested_by: "Didi Kidder",
    lead_id: 237465,
    comment: "Bad contact info bad conatct info",
    credits: 10,
    respond_date: moment().format("MMMM Do, YYYY"),
  },
  {
    status: "Pending",
    name: "DanielleDiaz",
    email: "xxdaniellad@yahoo.com",
    requested_by: "Didi Kidder",
    lead_id: 237465,
    comment: "Bad contact info bad conatct info",
    credits: 10,
    respond_date: moment().format("MMMM Do, YYYY"),
  },
  {
    status: "Pending",
    name: "DanielleDiaz",
    email: "xxdaniellad@yahoo.com",
    requested_by: "Didi Kidder",
    lead_id: 237465,
    comment: "Bad contact info bad conatct info",
    credits: 10,
    respond_date: moment().format("MMMM Do, YYYY"),
  },
  {
    status: "Pending",
    name: "DanielleDiaz",
    email: "xxdaniellad@yahoo.com",
    requested_by: "Didi Kidder",
    lead_id: 237465,
    comment: "Bad contact info bad conatct info",
    credits: 10,
    respond_date: moment().format("MMMM Do, YYYY"),
  },
  {
    status: "Pending",
    name: "DanielleDiaz",
    email: "xxdaniellad@yahoo.com",
    requested_by: "Didi Kidder",
    lead_id: 237465,
    comment: "Bad contact info bad conatct info",
    credits: 10,
    respond_date: moment().format("MMMM Do, YYYY"),
  },
];

export const comparedYearData = [
  {
    id: 6,
    text: "Previous period",
  },
  {
    id: 7,
    text: "Previous year",
  },
];

export const calendarData = [
  {
    id: 1,
    text: "All",
    period: {
      start: '01/01/2020',
      end: formatDate(currentDate),
    },
  },
  {
    id: 2,
    text: "Today",
    period: {
      start: '01/01/2020',
      start: formatDate(currentDate),
      end: formatDate(currentDate),
    },
  },
  {
    id: 3,
    text: "Month to date",
    period: {
      start: formatDate(monthStartDate),
      end: formatDate(currentDate),
    },
  },
  {
    id: 4,
    text: "Quarter to date",
    period: {
      start: formatDate(quarterStartDate),
      end: formatDate(currentDate),
    },
  },
  {
    id: 5,
    text: "Year to date",
    period: {
      start: formatDate(yearStartDate),
      end: formatDate(currentDate),
    },
  },
  {
    id: 6,
    text: "Custom date",
    period: {
      start: formatDate(currentDate),
      end: formatDate(currentDate),
    },
  },
];

export const professionsToolTable = [
  {
    id: 237645,
    name: "Private Doctors",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237646,
    name: "Dentist",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237647,
    name: "Private Doctors",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237678,
    name: "Private Doctors",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 234546,
    name: "Dentist",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 267647,
    name: "Private Doctors",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
];

export const divisionsToolTable = [
  {
    id: 645,
    name: "General Doctors",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 236,
    name: "Orthodentist",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 247,
    name: "Periodontics",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 237,
    name: "Oral and Maxillofacial Surgery",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 346,
    name: "Pediatric Dentistry",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
  {
    id: 267,
    name: "Orthodontics",
    price_per_lead: 100,
    divisions: 12,
    services: 14,
    created_at: moment().format("MMMM Do, YYYY"),
  },
];

export const tableMenuItems = [
  {
    id: 1,
    icon: AdjustmentsVerticalIcon,
    label: "Edit",
    value: "edit",
  },
  {
    id: 2,
    icon: XMarkIcon,
    label: "Delete",
    value: "delete",
  },
];

export const tableMenuMatchedItems = [
  {
    id: 1,
    icon: XMarkIcon,
    label: "Delete",
    value: "delete",
  },
];

export const tableMenuUnmatchedItems = [
  {
    id: 1,
    icon: XMarkIcon,
    label: "Delete",
    value: "delete",
  },
];

export const tableMenuPendingItems = [
  {
    id: 1,
    icon: XMarkIcon,
    label: "Delete",
    value: "delete",
  },
];

export const alertMenuItems = [
  {
    id: 1,
    icon: AdjustmentsVerticalIcon,
    label: "Edit",
    value: "edit",
  },
  {
    id: 2,
    icon: DocumentDuplicateIcon,
    label: "Duplicate",
    value: "duplicate",
  },
  {
    id: 3,
    icon: XMarkIcon,
    label: "Delete",
    value: "delete",
  },
];

export const alertSlideOverColors = [
  {
    id: 1,
    py_color: "#EBDCFF",
    sy_color: "#7D34D8",
  },
  {
    id: 2,
    py_color: "#FFD7F1",
    sy_color: "#ff34b8",
  },
  {
    id: 3,
    py_color: "#D2ECFF",
    sy_color: "#34a9ff",
  },
  {
    id: 4,
    py_color: "#C2FFE5",
    sy_color: "#34ffa8",
  },
];

export const templateCardDetail = [
  {
    id: 1,
    title: "Financial Report",
    description:
      "Daily e-mail sent with financial information. Daily Matches and expected revenue.",
    event: "Daily",
  },
  {
    id: 2,
    title: "New Lead",
    description:
      "E-Mail sent to the provider when a Match between a lead and a provider is created.",
    event: "Match Created",
  },
  {
    id: 3,
    title: "User Created",
    description: "E-mail sent to the user after an account is created.",
    event: "User Created",
  },
  {
    id: 4,
    title: "Provider Found",
    description:
      "E-mail sent to the lead when a match is created between the lead and the provider.",
    event: "Match Created",
  },
  {
    id: 5,
    title: "Virtual Session",
    description:
      "E-mail sent to the patient with information related to a virtual session.",
    event: "Manual Professional Action",
  },
  {
    id: 6,
    title: "Spam Notification",
    description: "E-mail sent when a new lead is marked as spam. ",
    event: "Lead is created",
  },
];

export const globalAlertData = [
  {
    id: 1,
    title: "System Updates",
    description:
      "A system update is scheduled for 09/03/2023 at 15.00 EST. During this time, users may experience temporary disruptions in service.",
    date: "XX/XX/XXXX",
    isAlert: false,
  },
  {
    id: 2,
    title: "GeneriCon 2023",
    description: "Join us in Denver from June 7 – 9 to see what’s coming next.",
    date: "XX/XX/XXXX",
    isAlert: false,
  },
  {
    id: 3,
    title: "System Updates",
    description:
      "A system update is scheduled for 09/03/2023 at 15.00 EST. During this time, users may experience temporary disruptions in service.",
    date: "XX/XX/XXXX",
    isAlert: false,
  },
  {
    id: 4,
    title: "System Updates",
    description:
      "A system update is scheduled for 09/03/2023 at 15.00 EST. During this time, users may experience temporary disruptions in service.",
    date: "XX/XX/XXXX",
    isAlert: false,
  },
  {
    id: 5,
    title: "GeneriCon 2023",
    description: "Join us in Denver from June 7 – 9 to see what’s coming next.",
    date: "XX/XX/XXXX",
    isAlert: false,
  },
  {
    id: 6,
    title: "System Updates",
    description:
      "A system update is scheduled for 09/03/2023 at 15.00 EST. During this time, users may experience temporary disruptions in service.",
    date: "XX/XX/XXXX",
    isAlert: false,
  },
];

export const professionalReviewsItems = [
  {
    id: 1,
    icon: XMarkIcon,
    label: "Delete",
  },
];

export const creditRequestFilterData = [
  {
    id: 1,
    name: "Newest",
  },
  {
    id: 2,
    name: "Oldest",
  },
];

export const states = [
  {
    value: "AL",
    name: "Alabama",
  },
  {
    value: "AK",
    name: "Alaska",
  },
  {
    value: "AZ",
    name: "Arizona",
  },
  {
    value: "AR",
    name: "Arkansas",
  },
  {
    value: "CA",
    name: "California",
  },
  {
    value: "CO",
    name: "Colorado",
  },
  {
    value: "CT",
    name: "Connecticut",
  },
  {
    value: "DE",
    name: "Delaware",
  },
  {
    value: "DC",
    name: "District Of Columbia",
  },
  {
    value: "FL",
    name: "Florida",
  },
  {
    value: "GA",
    name: "Georgia",
  },
  {
    value: "HI",
    name: "Hawaii",
  },
  {
    value: "ID",
    name: "Idaho",
  },
  {
    value: "IL",
    name: "Illinois",
  },
  {
    value: "IN",
    name: "Indiana",
  },
  {
    value: "IA",
    name: "Iowa",
  },
  {
    value: "KS",
    name: "Kansas",
  },
  {
    value: "KY",
    name: "Kentucky",
  },
  {
    value: "LA",
    name: "Louisiana",
  },
  {
    value: "ME",
    name: "Maine",
  },
  {
    value: "MD",
    name: "Maryland",
  },
  {
    value: "MA",
    name: "Massachusetts",
  },
  {
    value: "MI",
    name: "Michigan",
  },
  {
    value: "MN",
    name: "Minnesota",
  },
  {
    value: "MS",
    name: "Mississippi",
  },
  {
    value: "MO",
    name: "Missouri",
  },
  {
    value: "MT",
    name: "Montana",
  },
  {
    value: "NE",
    name: "Nebraska",
  },
  {
    value: "NV",
    name: "Nevada",
  },
  {
    value: "NH",
    name: "New Hampshire",
  },
  {
    value: "NJ",
    name: "New Jersey",
  },
  {
    value: "NM",
    name: "New Mexico",
  },
  {
    value: "NY",
    name: "New York",
  },
  {
    value: "NC",
    name: "North Carolina",
  },
  {
    value: "ND",
    name: "North Dakota",
  },
  {
    value: "OH",
    name: "Ohio",
  },
  {
    value: "OK",
    name: "Oklahoma",
  },
  {
    value: "OR",
    name: "Oregon",
  },
  {
    value: "PA",
    name: "Pennsylvania",
  },
  {
    value: "RI",
    name: "Rhode Island",
  },
  {
    value: "SC",
    name: "South Carolina",
  },
  {
    value: "SD",
    name: "South Dakota",
  },
  {
    value: "TN",
    name: "Tennessee",
  },
  {
    value: "TX",
    name: "Texas",
  },
  {
    value: "UT",
    name: "Utah",
  },
  {
    value: "VT",
    name: "Vermont",
  },
  {
    value: "VA",
    name: "Virginia",
  },
  {
    value: "WA",
    name: "Washington",
  },
  {
    value: "WV",
    name: "West Virginia",
  },
  {
    value: "WI",
    name: "Wisconsin",
  },
  {
    value: "WY",
    name: "Wyoming",
  },
];
